import { Box, useTheme } from '@mui/system';
import { APP_ROUTES } from 'constants/routes';
import React from 'react';
import { useNavigateNoUpdates } from 'routes/RouterUtils';
import { ITheme } from 'types/theme';

interface IProps {
	width: number;
	height?: number;
	navigation?: boolean;
}

const DescopeLogo = React.forwardRef<HTMLImageElement, IProps>(
	({ width, height, navigation }, forwardedRef) => {
		const theme = useTheme<ITheme>();
		const navigate = useNavigateNoUpdates();
		const alt = intl.tr('app.name');

		const handleClick = React.useCallback(() => {
			if (navigation) {
				navigate(APP_ROUTES.default);
			}
		}, [navigation, navigate]);

		return (
			<Box
				onClick={handleClick}
				data-testid="descope-logo-img"
				sx={{
					cursor: navigation ? 'pointer' : 'default'
				}}
			>
				<img
					id="descope-logo-img"
					src={theme.assets.descope.DescopeLogo()}
					alt={alt}
					ref={forwardedRef}
					width={width}
					height={height}
				/>
			</Box>
		);
	}
);

DescopeLogo.defaultProps = {
	height: -1, // auto height
	navigation: false
};

export default DescopeLogo;
